import React, { useState } from "react";
import { MdOutlineArrowBackIos, MdOutlineArrowForwardIos } from "react-icons/md";
import { HiChevronLeft, HiChevronDown, HiSearch, HiChevronRight, HiOutlineMail } from 'react-icons/hi';
import moment from 'moment';

export default function UpdateDataView({
  updateFormData = {},
  saveUpdateAssign,
  closeUpdateAssign,
  setUpdateFormData = () => { },
  getInsightSurveyListData = [],
  getCaseStudyListData = [],
  getRolePlayListData = [],
  getInsightMailLibraryListData = []
}) {
  const [isEdit, setIsEdit] = useState(true);
  const [activeTab, handleTabClick] = useState(1);

  const handleChange = (key, value) => {
    setUpdateFormData({
      ...updateFormData,
      [key]: value
    });
  };

  const handleEmployeeChange = (key, value) => {
    setUpdateFormData({
      ...updateFormData,
      employeeId: {
        ...updateFormData.employeeId,
        [key]: value
      }
    });
  };

  const getNameById = (list, id) => {
    const item = list.find((i) => i.id === id);
    return item ? item.name : "-";
  };

  const getMailNames = (ids = []) => {
    return ids.map((id) => {
      const mail = getInsightMailLibraryListData.find((m) => m.id === id);
      return mail ? mail.subject : id;
    });
  };

  const mails = getMailNames(updateFormData.mailIdList || []);

  const tabs = [
    {
      id: 1,
      label: 'Assign Activities'
    },
    {
      id: 2,
      label: 'Assign Emails'
    }
  ];


  const assessmentFields = [
    {
      id: 1,
      label: "Introduction & Orientation to Platform",
      type: "input",
      field: "introMeetingLink",
      placeholder: "Introduction Meeting Link",
    },
    {
      id: 2,
      label: "Case Study Reading & Preparation",
      type: "select",
      field: "caseStudyId",
      options: getCaseStudyListData,
      placeholder: "Select Case Study",
    },
    {
      id: 3,
      label: "Customer Roleplay Preparation",
      type: "select",
      field: "rolePlayId",
      options: getRolePlayListData,
      placeholder: "Select Role Play",
    },
    {
      id: 4,
      label: "MS Teams Meeting Links (BEI, Case Study & Roleplay)",
      type: "input",
      field: "rolePlayMeetingLink",
      placeholder: "Role Play Meeting Link",
    },
    {
      id: 5,
      label: "Situational Judgement Test",
      type: "select",
      field: "surveyId",
      options: getInsightSurveyListData,
      placeholder: "Select Survey",
    },
    {
      id: 6,
      label: "Inbox Activty",
      type: "list",
      field: "inboxActivity",
      placeholder: "Inbox Activty",
    },
  ];


  console.log("updateFormData--1--->", updateFormData)

  return (
    <div className="min-h-screen z-50 bg-black bg-opacity-50 p-4 fixed inset-0 flex justify-center items-center">
      <div className="md:px-8 px-4 py-6 bg-white rounded-2xl shadow-xl w-full max-w-5xl border border-gray-300 overflow-hidden">

        {/* HEADER */}
        <div className="flex justify-between items-center flex-wrap mb-5">
          <div>
            <h2 className="md:text-lg text-base font-semibold textblack">Employee Details</h2>
            <p className="text-sm textblack mt-1">
              <span className="font-semibold">Name:</span> {updateFormData?.employeeId?.name || ""}
              <span className="mx-4">|</span>
              <span className="font-semibold">Email:</span> {updateFormData?.employeeId?.email || ""}
            </p>
          </div>
        </div>


        {/* Tabs Container */}
        <div className="border-b border-gray-300">
          <nav className="flex gap-6 px-2" aria-label="Tabs">
            {tabs.map((tab) => {
              const isActive = activeTab === tab.id;

              return (
                <button
                  key={tab.id}
                  onClick={() => handleTabClick(tab.id)}
                  className={`relative py-3 text-base font-medium transition-all duration-200 whitespace-nowrap
            ${isActive
                      ? "text-indigo-600"
                      : "textblack hover:text-indigo-600"
                    }`}
                >
                  {tab.label}

                  {/* Active Border */}
                  <span
                    className={`absolute left-0 bottom-0 h-[3px] w-full rounded-full transition-all duration-300
              ${isActive
                        ? "bg-indigo-600"
                        : "bg-transparent"
                      }`}
                  />
                </button>
              );
            })}
          </nav>
        </div>


        {activeTab === 1 ?
          <>
            {/* GRID */}
            <div className="mt-5">
              {isEdit ? (
                <>
                  <div className="overflow-x-auto overflow-y-auto max-h-96 scrollbar">
                    <table className="w-full border border-gray-200 rounded-lg">
                      <thead className="bg-gray-100 sticky top-0">
                        <tr>
                          <th className="border px-4 py-3 text-left text-sm font-semibold w-[35%]">
                            Assessment
                          </th>
                          <th className="border px-4 py-3 text-left text-sm font-semibold">
                            Link / Selection
                          </th>
                          <th className="border px-4 py-3 text-center text-sm font-semibold w-44">
                            Expiry Date
                          </th>
                          <th className="border px-4 py-3 text-center text-sm font-semibold w-28">
                            Expired
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {assessmentFields.map((item) => (
                          <tr key={item.id} className="hover:bg-gray-50">
                            {/* Assessment Name */}
                            <td className="border px-4 py-3 text-sm font-medium">
                              {item.id}. {item.label}
                            </td>

                            {/* Input / Select */}
                            <td className="border px-4 py-3">
                              {item.type === "input" ? (
                                <input
                                  type="text"
                                  placeholder={item.placeholder}
                                  value={updateFormData?.[item.field] || ""}
                                  onChange={(e) =>
                                    handleChange(item.field, e.target.value)
                                  }
                                  className="w-full border border-gray-300 rounded-lg px-3 py-2 outline-none"
                                />
                              ) :
                                (item.type === "list" ? (
                                  <div>
                                    <div className="text-center">Inbox Activity</div>
                                  </div>
                                ) :
                                  (
                                    <div className="relative">
                                      <select
                                        value={updateFormData?.[item.field] || ""}
                                        onChange={(e) =>
                                          handleChange(item.field, e.target.value)
                                        }
                                        className="w-full border border-gray-300 rounded-lg px-3 py-2 pr-10 appearance-none outline-none"
                                      >
                                        <option value="">{item.placeholder}</option>

                                        {item.options.map((option) => (
                                          <option key={option.id} value={option.id}>
                                            {option.name}
                                          </option>
                                        ))}
                                      </select>

                                      <HiChevronDown className="absolute right-3 top-1/2 -translate-y-1/2 textblack text-xl pointer-events-none" />
                                    </div>
                                  ))
                              }
                            </td>

                            {/* Expiry Date */}
                            <td className="border px-4 py-3">
                              <input
                                type="date"
                                value={updateFormData?.[`${item.field}Expiry`] || ""}
                                onChange={(e) =>
                                  handleChange(`${item.field}Expiry`, e.target.value)
                                }
                                className={((moment().isAfter(moment((updateFormData?.[`${item.field}Expiry`] || ""), "YYYY-MM-DD"), "day")) ?
                                  "border border-red-300 text-red-500"
                                  : "border border-gray-300 text-gray-500") +
                                  " w-full  rounded-lg px-3 py-2 outline-none"}
                              />
                            </td>

                            {/* Status */}
                            <td className="border px-4 py-3 text-center">
                              <label className="inline-flex items-center gap-2 cursor-pointer">
                                <input
                                  type="checkbox"
                                  checked={updateFormData?.[`${item.field}Expired`] || false}
                                  onChange={(e) =>
                                    handleChange(
                                      `${item.field}Expired`,
                                      e.target.checked
                                    )
                                  }
                                />
                                <span className={(!(updateFormData?.[`${item.field}Expired`]) ? "text-green-500" : "text-red-500") + " text-sm font-medium"}>
                                  {!(updateFormData?.[`${item.field}Expired`]) ? "Active" : "Expired"}
                                </span>
                              </label>
                            </td>


                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </>
              ) : (
                <>
                  <div className="text-sm font-medium">
                    {updateFormData?.employeeId?.name || "-"}
                  </div>
                  <div className="text-xs text-gray-500">
                    {updateFormData?.employeeId?.email || "-"}
                  </div>
                </>
              )}
            </div>

          </>
          : null}

        {activeTab === 2 ?
          <>
            {/* MAILS */}
            <div className="mt-5">

              {isEdit ? (
                <div className="w-full">
                  <div className="w-full border border-gray-300 rounded-md overflow-hidden p-4 sm:p-6">

                    <div className="w-full overflow-x-auto scollbar">
                      <div className="min-w-[600px]">

                        <div className="overflow-y-auto max-h-96 scollbar">
                          {getInsightMailLibraryListData.length ? (
                            getInsightMailLibraryListData.map((mail) => (
                              <div
                                key={mail.id}
                                className="w-full flex items-start gap-3 p-3 sm:p-4 border-b border-gray-300 last:border-none hover:bg-gray-100"
                              >
                                <div className="pt-1 flex-shrink-0">
                                  <input
                                    type="checkbox"
                                    checked={updateFormData.mailIdList?.includes(mail.id)}
                                    onChange={() => {
                                      const current = updateFormData.mailIdList || [];
                                      const updated = current.includes(mail.id)
                                        ? current.filter((id) => id !== mail.id)
                                        : [...current, mail.id];

                                      handleChange("mailIdList", updated);
                                    }}
                                    className="w-4 h-4 rounded border-gray-300 text-indigo-600 cursor-pointer"
                                  />
                                </div>
                                {/* Icon */}
                                <div className="flex-shrink-0 w-9 h-9 sm:w-11 sm:h-11 bg-indigo-100 rounded-full flex items-center justify-center">
                                  <HiOutlineMail className="text-indigo-600 text-lg sm:text-xl" />
                                </div>

                                <div className="flex-1">
                                  <h3 className="text-sm sm:text-base font-semibold">{mail.subject}</h3>
                                  <div className="text-sm space-y-0.5">
                                    <p className="textblack whitespace-nowrap">
                                      <span className="font-medium textblack">From: </span>
                                      <span className="font-semibold">{mail.senderName}</span>
                                      <span className="textblack ml-1">({mail.senderEmail})</span>
                                    </p>
                                    <p className="textblack whitespace-nowrap">
                                      <span className="font-medium textblack">To: </span>
                                      <span className="font-semibold">{mail.recipientName}</span>
                                      <span className="textblack ml-1">({mail.recipientEmail})</span>
                                    </p>
                                  </div>
                                </div>

                                <div className="flex-shrink-0 text-right">
                                  <span className="text-xs sm:text-sm font-medium text-indigo-600 whitespace-nowrap">
                                    {mail?.createdAt ? new Date(mail.createdAt).toLocaleDateString() : ""}
                                  </span>
                                </div>
                              </div>
                            ))
                          ) : (
                            <div className="flex items-center justify-center h-32 text-gray-400 text-sm">
                              Data not available!
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="flex flex-wrap gap-2">
                  {mails.length ? (
                    mails.map((m, i) => (
                      <span
                        key={i}
                        className="text-xs px-3 py-1 bg-purple-100 text-indigo-600 rounded-md"
                      >
                        {m}
                      </span>
                    ))
                  ) : (
                    <div className="flex items-center justify-center w-full h-20 text-gray-400 text-sm">
                      Data not available!
                    </div>
                  )}
                </div>
              )}
            </div>
          </>
          : null}


        <div className="flex gap-2 mt-5 justify-end">
          <button
            onClick={() => closeUpdateAssign()}
            className=" text-indigo-600 border border-gray-300 text-base  px-4 py-2 rounded-md"
          >
            Close
          </button>
          <button
            onClick={() => saveUpdateAssign()}
            className="px-6 py-2 text-base font-semibold text-white bg-indigo-600 rounded-md hover:bg-indigo-700 active:scale-95 transition-all"
          >
            Update
          </button>
        </div>

      </div>
    </div>
  );
}